const UNSET_BUILD = 'dev';
const UNSET_ENVIRONMENT = 'local';

interface ThinkmdGlobal {
    env?: unknown;
    telemetry_enabled?: unknown;
}

function injected(): ThinkmdGlobal | undefined {
    return (globalThis as typeof globalThis & { thinkmd?: ThinkmdGlobal }).thinkmd;
}

export function buildNumber(): string {
    const hash = process.env.VUE_APP_GIT_HASH;
    return typeof hash === 'string' && hash ? hash : UNSET_BUILD;
}

export function environment(): string {
    const value = injected()?.env;

    if (typeof value !== 'string' || !value || value === 'undefined') {
        return UNSET_ENVIRONMENT;
    }

    return value;
}

// Mirrored from the server so the client never queues what the collector cannot accept.
export function telemetryEnabled(): boolean {
    return injected()?.telemetry_enabled === true;
}

export function offline(): boolean | undefined {
    const online = globalThis.navigator?.onLine;
    return typeof online === 'boolean' ? !online : undefined;
}
